import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/components/notFound/style.css'

export default function Submitted(){
	document.title = 'LSC | Application submitted'

	useEffect(() => {
		if (window.fbq) {
			window.fbq('track', 'CompleteRegistration', { currency: 'EGP', value: 0 })
		}
	}, [])
	return (
		<div className='applicationContainer'>
			<h2 style={{ textAlign: 'center' }}>
				Thank you for your interest in Life Sports Club. <br />
				A team member will get in touch with you <br />
				within 24 hours.
			</h2>
			<div className='applicationOptions'>
				<Link to={'/'}>
					<button>Home</button>
				</Link>
				<Link to={'/membership'}>
					<button>Back</button>
				</Link>
			</div>
		</div>
	)
}